/**
 * 查询键常量
 */
export const QUERY_KEYS = {
  BENEFIT_LIST: 'benefit-list',
  BENEFIT_DETAIL: 'benefit-detail',
  PRODUCT_STOCK_LIST: 'product-stock-list',
  BENEFIT_TYPE_LIST: 'benefit-type-list',
} as const;

/**
 * 抽屉配置
 */
export const DRAWER_CONFIG = {
  WIDTH: 800,
  PLACEMENT: 'right' as const,
} as const;

/**
 * 表单默认值
 */
export const FORM_DEFAULT_VALUES = {
  status: 1, // 默认启用
} as const;
